import { isStringEmpty } from "@/common/validation-checkers";

interface IProps {
    value?: string;
    purpose: string;
    newValue: (val: string | null) => void;
}

const TextAreaComponent: React.FC<IProps> = ({value, purpose, newValue}) => {

    return (
        <div className="mx-4 mt-1">
            <label className='py-1 block text-gray-200 text-md' htmlFor={purpose}>{purpose}</label>
            <textarea
                className="text-black px-2 py-1 block w-full"
                id={purpose}
                value={value || ""} 
                onChange={(event) => isStringEmpty(event.target.value) ? newValue(null) : newValue(event.target.value)} 
            />
        </div>
    )
}

export default TextAreaComponent;